import TimelineItemCircle, {
  TimeLineItemCircleType,
} from 'components/generics/Timeline/components/TimelineItem/components/TimelineItemCircle';
import TimelineItemText, {
  TimeLineItemTextType,
} from 'components/generics/Timeline/components/TimelineItem/components/TimelineItemText';
import classes from './index.module.scss';

export interface TimelineItemType
  extends TimeLineItemCircleType,
    TimeLineItemTextType {
  stopStep?: boolean;
}

const TimelineItem = (props: TimelineItemType) => {
  return (
    <>
      <TimelineItemCircle
        className={classes.circle}
        {...props}
      />
      <TimelineItemText
        className={classes.text}
        {...props}
      />
    </>
  );
};

export default TimelineItem;
